
import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyBcPd_9DF9zXxpSeFk0IzT3FjQGwOQ5I_g",
    authDomain: "kaiwa-deck-maker.firebaseapp.com",
    databaseURL: "https://kaiwa-deck-maker.firebaseio.com",
    projectId: "kaiwa-deck-maker",
    storageBucket: "kaiwa-deck-maker.appspot.com",
    messagingSenderId: "687816775184",
    appId: "1:687816775184:web:6e2b06fd59dc460ccb1c95"
}

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
}

export const db = firebase.firestore()

const { Timestamp, GeoPoint, FieldValue } = firebase.firestore
export { Timestamp, GeoPoint, FieldValue }